import useUserStore from "../stores/user";

export const useUrl = () => {
  const profile = useUserStore((state) => state.profile);

  const getDashboardUrl = () => {
    let url = "/login-portal";
    if (!profile) {
      return url;
    }

    const role = profile.role;

    if (role === "student") {
      url = "/dashboard";
    } else if (role === "teacher") {
      url = "/teacher/dashboard";
    } else if (role === "admin" || role === "district_admin") {
      url = "/admin/dashboard";
    } else if (role === "super_admin") {
      url = "/superadmin/dashboard";
    }

    return url;
  };

  return { getDashboardUrl };
};
